'use client';

import { Skeleton } from '@/components/ui';
import { Ticket, TicketSelectionSkeleton, CartSummary } from './components';
import { useTickets } from './hooks';
import { useSelector } from 'react-redux';

interface TProps {
  eventInfo: any;
}

const TicketSelection = ({ eventInfo }: TProps) => {
  const cartData = useSelector(
    (state: any) => state?.user?.cart,
  );
  const { loading, tickets, handleTicket, handleAddToCart } = useTickets({ eventInfo, cartData });

  return (
    <>
      <div className='w-full max-w-2xl p-4'>
        <div className='mb-4 w-full max-w-2xl rounded-xl border bg-white p-3 text-center font-bold text-gray-800 uppercase'>
          {loading ? (
            <Skeleton className='mx-auto h-5 w-[12rem] md:h-6' />
          ) : (
            <p>Select Ticket</p>
          )}
        </div>
        {loading ? (
          <TicketSelectionSkeleton />
        ) : (
          <div className='bg-transparent w-full min-h-84'>
            <div className='mx-auto flex max-w-2xl flex-col justify-center'>
              {tickets?.length > 0 ? (
                <></>
              ) : (
                <div className='mt-4 h-screen text-center text-gray-500'>
                  No tickets available
                </div>
              )}
              {tickets?.map((ticket: any) => (
                <Ticket
                  key={ticket?.code}
                  ticket={ticket}
                  cartData={cartData}
                  eventInfo={eventInfo}
                  handleTicket={handleTicket}
                />
              ))}
            </div>
          </div>
        )}
      </div>
      <CartSummary
        selectedTickets={cartData?.selectedTickets}
        handleAddToCart={handleAddToCart}
        eventType={eventInfo?.eventType}
      />
    </>
  );
};

export default TicketSelection;
